import { render, staticRenderFns } from "./DashboardIndexMain.vue?vue&type=template&id=06b20580&scoped=true"
import script from "./DashboardIndexMain.vue?vue&type=script&lang=js"
export * from "./DashboardIndexMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b20580",
  null
  
)

export default component.exports